import React, { Suspense } from 'react';
import { Router } from 'react-router-dom';
import { render } from 'react-dom';

import { history } from './_helpers';
import { accountService } from './_services';
import { Loading } from './_components';
import { App } from './app';



//load config, try token refresh, start app
accountService.configuration().finally(function () {
  
  // attempt silent token refresh before startup
  // If user is not logged in, this may return 400 with "Invalid token".
  // Swallow the error so dev overlay doesn't show.
  accountService.refreshToken()
      .catch(() => {
          //log to console
          console.log('Token refresh failed (not logged in)');
      }).finally(startApp);
});


function startApp() {
  render(

    <Router history={history}>
      <Suspense fallback={<Loading />}>
        <App  />
      </Suspense>
    </Router>,
    document.getElementById('app')

  );
}